// @greenlight-spec: 20-agent-plugins.md#marketplace-repo-bootstrap
// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: decisions/0040-multiple-plugin-marketplace-repositories.md

import * as React from 'react';

import type { AgentKind } from '@greenlight/shared';

const CLONING_AGENTS: readonly AgentKind[] = ['copilot', 'other'];

/**
 * Supported agents whose organization rollout still reads the marketplace from
 * GitHub on each machine. Claude, Codex and Cursor each sync it through their
 * own GitHub connection and serve members a copy.
 */
export function directCloneAgents(supportedAgents: readonly AgentKind[]): AgentKind[] {
  return supportedAgents.filter((agent) => CLONING_AGENTS.includes(agent));
}

/** The wizard always recommends a private repository; a public one is the fallback. */
export function MarketplaceVisibilityGuide(): React.JSX.Element {
  return (
    <div className="rounded-md border bg-muted/20 p-4" data-testid="marketplace-visibility-guide">
      <p className="text-sm font-medium" data-testid="marketplace-recommendation">
        Create a private repository.
      </p>
      <p className="mt-1 text-xs text-muted-foreground">
        Claude, Codex and Cursor each sync it through their own GitHub connection and serve members
        a copy, so nobody else needs GitHub access. Add a public repository later only as a
        fallback: for Copilot, for self-serve installs, or if OpenAI or Cursor cannot sync the
        private one.
      </p>
    </div>
  );
}
